module.exports = __webpack_public_path__ + "img/arrow-down.ff29ce73.svg";